import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { date } from "yup";
import { values } from "lodash";

interface IRQRemittanceHeader {
	// salaryProfileReportDDlItems?: { label: string; value: any }[];
	// onApplyButtonClickedHandler: () => void;
	// onEmployeeStatusSelectionChangeHandler: (params: any) => void;
	// selectedItem: any
	onManagedByChangeHandler: any
	remittanceFrequencyDDL: any
	rqRamittanceSavedFrequency: any
	csstDDL: any;
	onSubmitCSSTHandler: (values: any) => void;
	onSubmitHSFHandler: (values: any) => void;
	onRemittanceFrequencyChangeHandler: (values: any) => void;
	onCSSTDeleteClicked: () => void;
	onSavedCSSTSelectionChangeHandler: (value: any) => void;
	rqRamittanceSetup: any
	companyInformation: any
	selectedCSSTProfile: any
	taxYear: any
	hsfDataByClientIdndTaxYear: any
	onExportButtonClick: () => void;
}

export const RQRemittanceHeader: React.FC<
	IRQRemittanceHeader
> = ({ onManagedByChangeHandler, csstDDL, onSubmitCSSTHandler, onSubmitHSFHandler,
	onRemittanceFrequencyChangeHandler, remittanceFrequencyDDL, onCSSTDeleteClicked,
	onSavedCSSTSelectionChangeHandler, rqRamittanceSavedFrequency,
	rqRamittanceSetup, companyInformation, selectedCSSTProfile, taxYear, hsfDataByClientIdndTaxYear, onExportButtonClick}) => {

		return (
			<>
				<Grid
					container
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{
						background: "#fff",
						border: "1px solid #e5e7eb",
						borderBottom: 0,
						borderRadius: "2px 2px 0 0",
						padding: "31px 20px 2.5rem 20px",
						marginBottom: "0px!important",
						color: "#4b5563",
					}} columnSpacing={2}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .dropDownWrapper": { marginBottom: "38px!important", marginTop: "24px!important" },

						}}>
						<EnhancedDropDownRHF
							selectName="remittanceFrequencyId"
							testId={`rqRemittanceFrequency-list`}
							items={remittanceFrequencyDDL ?? []}
							onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
							showEmpty
							selectedItem={null}
							isDisabled={rqRamittanceSetup && rqRamittanceSetup.items && rqRamittanceSetup.items.some((item: any) => item.status === 'Remitted') ? true : false}
						/>
						<EnhancedDropDownRHF
							selectName="managedBy"
							testId={`managed_by-list`}
							items={
								companyInformation && companyInformation.paymentSetup === 100 ?
									[{ label: "Self Managed", value: 200 }] :
									[
										{ label: "Managed by Simplepay", value: 100 },
										{ label: "Self Managed", value: 200 },
									]}
							isDisabled={companyInformation && companyInformation.paymentSetup === 100 ? true : false}
							selectedItem={200}
							onSelectionChangeHandler={onManagedByChangeHandler}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							fontSize: "0.875rem",
							color: "#4b5563",
							"& .calenderWrapper ": { fontSize: ".875rem", marginBottom: "15px!important", width: "296px!important" },
							"& .MuiGrid-root ": { width: "296px!important", marginBottom: "0px!important" },
							"& .dropDownWrapper": { marginBottom: "15px!important" },
							"& .numberFieldWrapper": { marginBottom: "15px!important", width: "250px!important" },
						}}>
						<EnhancedDropDownRHFWithLabel
							selectName="savedCSSTProfiles"
							// items={[
							// 	{ label: "jan 01 2025", value: 100 },
							// 	{ label: "jan 02 2025", value: 200 },
							// ]}
							items={csstDDL ?? []}
							label={"Saved CSST Profiles"}
							testId={"saved-csst-profiles"}
							selectedItem={"new-rate"}
							onSelectionChangeHandler={onSavedCSSTSelectionChangeHandler}

						/>

						<Grid
							sx={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								"& .enhanced-button": {
									padding: '0.7rem 1.09375rem 0.69rem 1.09375rem !important',
									border: '1px solid #d1d5db',
									borderRadius: 0,
									marginTop: '9px',
									borderLeft: 0,
								}
							}}
						>
							<RHookFormNumberFieldWithLabel
								label="Rate"
								id="rate"
								testId={`rq-rate`}
							/>
							{selectedCSSTProfile && selectedCSSTProfile !== "new-rate" && <EnhancedButtonPrimeReact
								icon="pi pi-times"
								severity={EnhancedButtonPrimeReactSeverity.Danger}
								className="p-button-rounded p-button-text ml-2 shadow-none bg-transparent"
								rounded
								onClickHandler={
									onCSSTDeleteClicked
								}
							/>}
						</Grid>
						<RHookFormDatePicker
							name="effectiveDate"
							testId="date-effective"
							label="Effective Date"
							labelPosition={LabelPosition.Top}
						/>
						<EnhancedButtonPrimeReact
							label="Save CSST"
							raised
							// type="submit"
							onClickHandler={() => onSubmitCSSTHandler(values)}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}
					>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							color: "#4b5563", fontSize: "0.875rem",
							"& .numberFieldWrapper": { marginBottom: "15px!important" },
							"& .dropDownWrapper": { marginBottom: "15px!important" },

						}}>

						<Typography
							sx={{
								marginBottom: "25px",
								marginTop: "31px",
								fontSize: "0.875rem"
							}}
						>
							HSF Rate for {taxYear}
							{/* <span>&nbsp;&nbsp;1.65</span> */}
							<span>&nbsp;&nbsp;{hsfDataByClientIdndTaxYear && hsfDataByClientIdndTaxYear.hsfRate}</span>
						</Typography>
						<EnhancedDropDownRHFWithLabel
							selectName="businessStartedBeforeYear"
							label={`Business started before ${taxYear - 1}?`}
							items={[
								{ label: "Yes", value: 200 },
								{ label: "No", value: 100 },
							]}
							selectedItem={200}
							testId={`business-started-before`}

						/>
						<RHookFormNumberFieldWithLabel
							label={`Total Gross Paid in ${taxYear - 1}`}
							id="totalGrossPaidInYear"
							testId={`total-gross-paid`}

						/>
						<EnhancedButtonPrimeReact
							label="Save HSF"
							raised
							// type="submit"
							onClickHandler={() => onSubmitHSFHandler(values)}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>

					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
						sx={{ fontSize: "0.875rem", textAlign: "Right", color: "#4b5563" }}
					>
						QST Registration No: {" "}
						{/* <span>1212121211</span>
						<span>RS</span>
						<span>0001</span> */}
						{companyInformation && companyInformation.craBusinessNo?.replace(/\s*RP\s*/g, " RP ")}
						<br />
						<Link
							to={"#"}
							className="no-underline"
							onClick={onExportButtonClick}
						>
							<span style={{ color: "#0091b3" }}>Export to Excel</span> <br />
						</Link>
					</Grid>
				</Grid >
			</>
		);
	};



